/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/feeAudit.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getFeeAuditData,
  createFeeAudit,
  AgreeFeeAudit,
  rejectFeeAudit,
  getFeeAuditInfo,
  deleteFeeAudit,
  downloadFeeAudit
} from "@/service/feeAuditService";
const feeAudit = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取group列表
     */
    getFeeAuditData(store, info) {
      return new Promise((resolve, reject) => {
        getFeeAuditData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建用户组
     * @param {*} store
     * @param {*} data
     */
    createFeeAudit(store, data) {
      return new Promise((resolve, reject) => {
        createFeeAudit(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取用户组详情
     * @param {*} store
     * @param {*} id
     */
    getFeeAuditInfo(store, id) {
      return new Promise((resolve, reject) => {
        getFeeAuditInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 同意审批
     * @param {*} store
     * @param {*} data
     */
    AgreeFeeAudit(store, data) {
      return new Promise((resolve, reject) => {
        AgreeFeeAudit(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 拒绝审批
     * @param {*} store
     * @param {*} data
     */
    rejectFeeAudit(store, data) {
      return new Promise((resolve, reject) => {
        rejectFeeAudit(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除用户组
     * @param {*} store
     * @param {*} id
     */
    deleteFeeAudit(store, id) {
      return new Promise((resolve, reject) => {
        deleteFeeAudit(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 下载zip
     * @param {*} store
     * @param {*} id
     */
    downloadFeeAudit(store, id) {
      return new Promise((resolve, reject) => {
        downloadFeeAudit(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default feeAudit;



// WEBPACK FOOTER //
// ./src/store/modules/feeAudit.js